var map = {
	"./badge.svg": 1117,
	"./chat.svg": 1118,
	"./check.svg": 1119,
	"./checked-circle.svg": 1120,
	"./checked-icon.svg": 1121,
	"./checkmark.svg": 1122,
	"./close-fill.svg": 1123,
	"./close-outline.svg": 1124,
	"./close.svg": 1125,
	"./comment.svg": 1126,
	"./comments.svg": 1127,
	"./consultation-deselected.svg": 1128,
	"./dashboard.svg": 1129,
	"./facebook-circle.svg": 1130,
	"./facebook.svg": 1131,
	"./funnel.svg": 1132,
	"./getcall.svg": 1133,
	"./google.svg": 1134,
	"./hide.svg": 1135,
	"./horn.svg": 1136,
	"./loader-spinner.svg": 1137,
	"./lock.svg": 1138,
	"./money-transfer.svg": 1139,
	"./new-projects.svg": 1140,
	"./pending-projects.svg": 1141,
	"./play-active.svg": 1142,
	"./play-inactive.svg": 1143,
	"./projects-in-progress.svg": 1144,
	"./questionmark.svg": 1145,
	"./show.svg": 1146,
	"./stripe.svg": 1147,
	"./support.svg": 1148,
	"./twitter.svg": 1149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1116;